<template>
  <article
    v-if="post"
    class="post"
    :style="{ backgroundColor: backgroundColor }"
    @click="openPost(post.id)"
  >
    <PostHeader :post="post" :isRemakeFeed="isRemakeFeed" />

    <PostSwiper :post="post" :isModal="isModal" :visible="isVisible" />

    <section class="post_bottom">
      <div class="post_bottom_btn">
        <LikeBtn :post="post" />
        <CommentBtn
          :post="post"
          @click.stop="openComments"
          :class="{ active: commentVisible }"
        />
      </div>

      <RemakeBtn :post="post" />
    </section>
  </article>

  <div v-else>
    <p class="post_not_found">{{ $t("postNotFound") }}</p>
  </div>
</template>

<script>
import { defineAsyncComponent } from "vue";
import PostSwiper from "./PostSwiper.vue";
import RemakeBtn from "@/UI/Button/RemakeBtn.vue";
import { useOpenPost } from "../../composables/useOpenPost.js";
import CommentBtn from "../../UI/Button/CommentBtn.vue";
import LikeBtn from "../../UI/Button/LikeBtn.vue";
import { usePostActions } from "../../composables/usePostActions.js";

export default {
  name: "Post",
  emits: ["toggleComments"],
  components: {
    PostHeader: defineAsyncComponent(() => import("./PostHeader.vue")),
    PostSwiper,
    RemakeBtn,
    CommentBtn,
    LikeBtn,
  },
  props: {
    post: {
      type: Object,
      required: false,
    },
    isRemakeFeed: {
      type: Boolean,
      default: false,
    },
    isModal: {
      type: Boolean,
      default: false,
    },
    commentVisible: {
      type: Boolean,
    },
  },
  data() {
    return {
      openPostError: false,
      openPost: null,
      isVisible: false,
      observer: null,
      backgroundColor: usePostActions(this.post).backgroundColor,
      openComments: usePostActions(this.post, this.isModal, this.$emit)
        .openComments,
    };
  },
  mounted() {
    this.openPost = useOpenPost([this.post]).openPost;

    this.observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          this.isVisible = true;
          this.observer.disconnect();
        }
      },
      { threshold: 0.3 },
    );

    this.observer.observe(this.$el);
  },
};
</script>

<style>
.post,
.post-slider,
.swiper-slide,
.collage-container {
  overflow: hidden;
  box-sizing: border-box;
}

.post {
  border-radius: 31px;
  overflow: hidden;
  margin-bottom: 20px;
  padding: 16px 0;
  cursor: pointer;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  aspect-ratio: 9 / 15;
  width: 100%;
  height: auto;
  box-shadow: 0px 0px 15px 2px rgba(0, 0, 0, 0.1);
  max-width: 100%;
  z-index: 5;
}

.defualt .post {
  background-color: var(--header-color);
}

.short .post {
  height: 310px;
}

.post_bottom {
  display: flex;
  justify-content: space-between;
  padding: 0 14px;
  margin-top: 16px;
}

.post_bottom_btn {
  display: flex;
  gap: 10px;
}

.post_not_found {
  background-color: var(--header-color);
  padding: 20px;
  border-radius: 10px;
}
</style>
